import React from "react"

const RequiredMarkContext = React.createContext(false)

type RequiredMarkProviderProps = {
    show?: boolean
    children: React.ReactNode
}

// the asterisk on a required field only means something next to a legend explaining it,
// so forms opt in by wrapping their fields instead of every field showing one by default
const RequiredMarkProvider = ({ show = true, children }: RequiredMarkProviderProps) => (
    <RequiredMarkContext.Provider value={show}>{children}</RequiredMarkContext.Provider>
)

const useRequiredMark = () => React.useContext(RequiredMarkContext)

export { RequiredMarkProvider, useRequiredMark }
